import { createFileRoute, redirect } from '@tanstack/react-router';

// Triggers were folded into Your Actions (an event-triggered action IS a
// trigger). Old bookmarks land on the Library.
export const Route = createFileRoute('/_auth/_side-layout/triggers')({
  beforeLoad: () => {
    throw redirect({ to: '/actions/your-actions/actions', search: {} });
  },
});
